import React, { Component, useEffect, useMemo, useRef, useState } from "react";
import * as SurveyAnalytics from "survey-analytics";
import "survey-analytics/survey.analytics.css";
import jsPDF from "jspdf";
import ExcelJS from "exceljs";
import "jspdf-autotable";
import * as SurveyAnalyticsTabulator from "survey-analytics/survey.analytics.tabulator";
import "tabulator-tables/dist/css/tabulator.css";
import "survey-analytics/survey.analytics.tabulator.css";
import { Model } from "survey-core";
import PrimaryButton from "../Button/PrimaryButton";
import i18next, { t } from "i18next";
import RezultataiClass from "../../clases/rezultatai";
import { useTranslation } from "react-i18next";
window.jsPDF = jsPDF;

const SurveyAnalyticsTabulatorOptions = {
    haveCommercialLicense: true,
    downloadOptions: { fileName: "my_file", csv: { delimiter: ';' } },
    // showTitles: true,
    // useValuesAsLabels: true,
}
const SurveyAnalyticsComponentExports = ({ data, json }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingType, setLoadingType] = useState('');

    const Rezai = useMemo(() => new RezultataiClass({
        nerodyti: {
            pages: t('pslNerodoCSV'),
        }
    }), [t]);

    const handleExport = async (type) => {
        if (!json?.[0]?.attributes?.formObject || !data?.length || isLoading) return;
        
        setIsLoading(true);
        setLoadingType(type);
        try {
            // Initialize survey and process data
            const survey = new Model(Rezai.tipaiBeNereikalinguPuslapiu(json[0].attributes.formObject));
            survey.locale = i18next.language;

            // Get all questions from the survey
            const allQuestions = [];
            survey.getAllQuestions().forEach(question => {
                if (question.name) {
                    allQuestions.push({
                        name: question.name,
                        title: question.title || question.name,
                        type: question.getType()
                    });
                }
            });

            // Create export data structure
            const exportData = data.map(item => {
                const answers = item.attributes?.atsakymai || {};
                const rowData = {};

                allQuestions.forEach(question => {
                    let value = answers[question.name];

                    // Handle different value types
                    if (value !== undefined && value !== null) {
                        if (Array.isArray(value)) {
                            // For checkbox/multiple choice questions
                            value = value.join(', ');
                        } else if (typeof value === 'object') {
                            // For matrix/rating questions
                            if (value.text) {
                                value = value.text;
                            } else if (value.value !== undefined) {
                                value = value.value;
                            } else {
                                const values = [];
                                Object.entries(value).forEach(([key, val]) => {
                                    if (val && typeof val === 'object' && val.text) {
                                        values.push(`${key}: ${val.text}`);
                                    } else if (val !== null && val !== undefined) {
                                        values.push(`${key}: ${val}`);
                                    }
                                });
                                value = values.join('; ');
                            }
                        }
                    } else {
                        value = '';
                    }

                    rowData[question.title] = value;
                });

                return rowData;
            });

            const headers = allQuestions.map(q => q.title);

            if (type === 'xlsx') {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet(t('rezultataiRezultatai'));

                // Add headers
                worksheet.addRow(headers);

                // Add data
                exportData.forEach(rowData => {
                    const row = headers.map(header => rowData[header] || '');
                    worksheet.addRow(row);
                });

                // Adjust column widths
                const maxWidth = 100;
                worksheet.columns.forEach((column, index) => {
                    column.width = Math.min(headers[index].length + 5, maxWidth);
                });

                // Generate and download the file
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${t('rezultataiRezultatai')}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else if (type === 'csv') {
                // Create CSV content with proper escaping
                const csvRows = exportData.map(row => {
                    return headers.map(header => {
                        const value = row[header];
                        const stringValue = value === null || value === undefined ? '' : String(value);
                        // Escape special characters and wrap in quotes if needed
                        return stringValue.includes(';') || stringValue.includes('"') || stringValue.includes('\n') ?
                            `"${stringValue.replace(/"/g, '""')}"` :
                            stringValue;
                    }).join(';');
                });

                const headerRow = headers.map(header => 
                    header.includes(';') ? `"${header.replace(/"/g, '""')}"` : header
                ).join(';');

                const csvContent = [headerRow, ...csvRows].join('\n');
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = t('rezultataiRezultatai') + '.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error('Export error:', error);
        } finally {
            setIsLoading(false);
            setLoadingType('');
        }
    };

    if (!json?.[0]?.attributes?.formObject || !data?.length) return null;

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            <PrimaryButton
                onClick={() => handleExport('xlsx')}
                disabled={isLoading}
                sx={{
                    backgroundColor: '#6C5DD3',
                    '&:hover': {
                        backgroundColor: '#5a4eb8'
                    }
                }}
            >
                {isLoading && loadingType === 'xlsx' ? (
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">{t('loading')}</span>
                        </div>
                        Ruošiami...
                    </div>
                ) : 'PARSISIŲSTI EXCEL'}
            </PrimaryButton>
            <PrimaryButton
                onClick={() => handleExport('csv')}
                disabled={isLoading}
                sx={{
                    backgroundColor: '#6C5DD3',
                    '&:hover': {
                        backgroundColor: '#5a4eb8'
                    }
                }}
            >
                {isLoading && loadingType === 'csv' ? (
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">{t('loading')}</span>
                        </div>
                        Ruošiami...
                    </div>
                ) : 'PARSISIŲSTI CSV'}
            </PrimaryButton>
        </div>
    );
};
export default SurveyAnalyticsComponentExports;
